import { useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'

import { logout } from '../../../../api/login'
import useApiCall from '../../../../api/useApiCall'
import { getMyAccount } from '../../../../api/users'
import { ReactComponent as ArrowDown } from '../../../../assets/icons/chevron-down.svg'
import { ReactComponent as ArrowUp } from '../../../../assets/icons/chevron-up.svg'
import { ReactComponent as LogOut } from '../../../../assets/icons/log-out.svg'
import { ReactComponent as Redirect } from '../../../../assets/icons/redirect.svg'
import useOnClickOutside from '../../../../hooks/useOnClickOutside'
import { useUserProfileStore } from '../../../../stores/userProfileStore'
import { clearLocalStorage } from '../../../../utils/auth'
import { getInitialsLetters } from '../../../../utils/text'

import { joinClassNames } from '../../../../utils/styles'
import styles from './profile.module.scss'

function Profile() {
    const { t } = useTranslation()

    const navigate = useNavigate()

    const [{ userProfile }, { setMyProfile }] = useUserProfileStore()

    useApiCall(getMyAccount, setMyProfile)

    const profileRef = useRef<HTMLDivElement>(null)
    const [isProfileOpen, setIsProfileOpen] = useState(false)

    useOnClickOutside(profileRef, () => setIsProfileOpen(false))

    const handleLogout = () => {
        clearLocalStorage()

        logout().then(() => {
            navigate('login')
        })
    }

    if (!userProfile) {
        return null
    }

    const { username, email } = userProfile

    return (
        <div className={styles.profile} ref={profileRef}>
            <button
                className={styles.profile__btn}
                onClick={() => setIsProfileOpen(true)}
            >
                <div className={styles.profile__initials}>
                    {getInitialsLetters(username)}
                </div>
                <div className={styles.profile__name}>{username}</div>
                <div className={styles.profile__arrows}>
                    <ArrowUp className={styles.profile__icon} />
                    <ArrowDown className={styles.profile__icon} />
                </div>
            </button>
            {isProfileOpen ? (
                <div className={styles.profile__dropdown}>
                    <Link to="/account" className={styles.profile__dropdownBtn}>
                        <Redirect className={styles.profile__dropdownIcon} />
                        {email}
                    </Link>
                    <button
                        className={joinClassNames(
                            styles.profile__dropdownBtn,
                            styles.profile__dropdownBtnLine
                        )}
                        onClick={handleLogout}
                    >
                        <LogOut className={styles.profile__dropdownIcon} />
                        {t('logout')}
                    </button>
                </div>
            ) : null}
        </div>
    )
}

export default Profile
